module.exports = __webpack_public_path__ + "img/h_bg.5c686c42.png";